/**
 * Returns a one-liner address description string.
 *
 * @param {Object} address The Address or ExternalShippingAddress.
 * @returns {string}
 */
export const getInlineAddressDescription = address => {
  if (!address?.address_line_1) {
    return '';
  }

  return [address.address_line_1, address.city, address.state]
    .filter(Boolean)
    .join(', ');
};
